import { ascend, descend, prop, sort } from 'ramda';

export const shuffleArray = (arr, field) => {
  let currentIndex = arr.length;
  let temporaryValue;
  let randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = arr[currentIndex];
    arr[currentIndex] = arr[randomIndex];
    arr[randomIndex] = temporaryValue;
  }

  if (field) {
    const dir = Math.random() > 0.5 ? ascend : descend;
    return sort(dir(prop(field)), arr);
  }

  return arr;
};
